module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        onSubmit
    } = props;

    return {
        onSubmit,
        defaults: {
            agreeToTerms: false
        },
        fields: [{
            type: 'CheckboxField',
            name: 'agreeToTerms'
        }]
    };
};
